import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';
import { DashboardService } from 'src/app/core/services/dashboard/dashboard.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-version-update',
  templateUrl: './version-update.component.html',
  styleUrls: ['./version-update.component.scss']
})
export class  VersionUpdateComponent implements OnInit {
  showNotification: boolean = true;
  fetchedUser:any;
  env = environment;
  constructor(
    public dialogRef: MatDialogRef<VersionUpdateComponent>,
    private dialog: MatDialog,
    private _localStorageService: LocalStorageService,
    private _loaderService: LoaderService,
     private _dashboardService: DashboardService,
  ) {}

  ngOnInit() {
    this.fetchedUser = this._localStorageService.getUser();
    // Check if popup should reopen after 1 minute
    const openPopup = localStorage.getItem('openPopup');
    if (openPopup === 'true') {
      setTimeout(() => {
        this.openPopup();
      }, 1000); // 1 minute (60000ms)
    }
    
  }

  updateNow() {
    // alert('Starting update process...');
    this.updateService({ appVersion: this.env?.APP_VERSION });
    this.dialogRef.close();
    
  }

  updateService(payload: { appVersion: string }) {
    this._loaderService.showLoader();

    // Calling the updateService with a dynamic payload
    this._dashboardService.updateService(payload, this.fetchedUser?.id).subscribe(
      (response) => {
        this._loaderService.hideLoader();
        console.log('Service updated successfully:', response);
        setTimeout(() => {
          this.logout();
        }, 3000)
      },
      (error) => {
        this._loaderService.hideLoader();
        console.error('Error updating service:', error);
      }
    );
}


  logout() {
    this._localStorageService.clearAll();
    this._localStorageService.removeSessionKey('');
    this._localStorageService.removeKey('access_token');
    window.location.replace('/authentication/login');
  }

  remindLater() {
    // alert('You will be reminded later');
    this.dialogRef.close(); // Close the popup
    let pOd= {
      time: moment(),
    }
    localStorage.setItem('updatePopupRemindMelater', JSON.stringify(pOd));
    // Set a timeout to reopen the popup after 1 minute
    setInterval(() => {
      this.showNotification = true;      
      this.openPopup();
    }, 43200000); // 12hours
  }

  openPopup() {
    this.dialog.open(VersionUpdateComponent, {
      width: '450px',
          enterAnimationDuration: '50ms',
          exitAnimationDuration: '100ms',
          disableClose: true,
          height: 'auto',
          panelClass: 'custom-dialog-container',
          data: { },
      });
  }
}
